import { Component } from '@angular/core';
import { BzgModalService, BzgModalRef } from 'bz-genome-angular';
import { DeleteConfirmationComponent } from 'app/shared/components/delete-confirmation/delete-confirmation.component';
import { DeleteCasesService } from './core/services/delete-cases.service';
import { EDeleteCasesState } from './core/delete-cases-state.enum';

@Component({
    selector: 'delete-cases',
    templateUrl: 'delete-cases.component.html',
    styleUrls: ['delete-cases.component.scss']
})
export class DeleteCasesComponent {
    private _deleteAlertComponent: BzgModalRef;
    private _statusVerification: any;
    private _currentState: EDeleteCasesState;

    constructor(private _modalService: BzgModalService,
        private _deleteCasesService: DeleteCasesService) {
        this._currentState = EDeleteCasesState.Waiting;
    }

    async ngOnInit() {
        await this.startVerification();
    }

    ngOnDestroy() {
        this.clearVerification();
    }

    public async delete() {
        this._deleteAlertComponent = this._modalService.open(DeleteConfirmationComponent, {
            closeOnBackdropClick: false,
            closeOnRouterNavigation: true,
            data: {
                title: 'DELETE_CASES.TITLE_CONFIRM',
                message: 'DELETE_CASES.CONFIRM_MSG',
                button: 'DELETE_CASES.CONFIRM_BTN_DELETE'
            }
        });
        this._deleteAlertComponent.afterClosed().subscribe(async (result) => {
            if (result === 'delete') {
                await this._deleteCasesService.startProcess();
                await this.startVerification();
            }
        });
    }

    public isInProgressOperation<Boolean>() { return this._currentState.toString() === 'InProgress' };
    public isSucceededOperation<Boolean>() { return this._currentState.toString() === 'Succeeded' };
    public isFailedOperation<Boolean>() { return this._currentState.toString() === 'Failed' };

    private async startVerification() {
        const state = await this._deleteCasesService.getState();
        this._currentState = ((state.status) as EDeleteCasesState);
        this._statusVerification = setInterval(async () => {
            if (!this.isInProgressOperation()) {
                this.clearVerification();
            }
            const stateDeleteCaess = await this._deleteCasesService.getState();
            this._currentState = ((stateDeleteCaess.status) as EDeleteCasesState);
        }, 3000);
    }

    private clearVerification() {
        if (this._statusVerification) {
            clearInterval(this._statusVerification);
        }
    }
}
